export const handleError = (err, defaultErrorMessage) => {
  let errorMessage;
  if (err.response && err.response.data) {
    // Check for errors array first (validation errors)
    if (err.response.data.errors && Array.isArray(err.response.data.errors) && err.response.data.errors.length > 0) {
      errorMessage = err.response.data.errors[0].message;
    } else {
      // Try to get the most specific error message available
      errorMessage = err.response.data.error || err.response.data.message || defaultErrorMessage;
    }
  } else {
    errorMessage = defaultErrorMessage;
  }
  
  // Create error object with both message and response properties for compatibility
  const error = new Error(errorMessage);
  error.error = errorMessage;
  error.response = err.response; // Preserve original response
  return error;
};
